export const isMultiPolygon = (
    value:
        | GeoJSON.Feature<GeoJSON.Polygon>
        | GeoJSON.Feature<GeoJSON.MultiPolygon>
        | GeoJSON.Feature<
              GeoJSON.Polygon | GeoJSON.MultiPolygon,
              GeoJSON.GeoJsonProperties
          >
): value is GeoJSON.Feature<GeoJSON.MultiPolygon> => {
    return value.geometry.type === "MultiPolygon";
};

export const isPolygon = (
    value:
        | GeoJSON.Feature<GeoJSON.Polygon>
        | GeoJSON.Feature<GeoJSON.MultiPolygon>
        | GeoJSON.Feature<
              GeoJSON.Polygon | GeoJSON.MultiPolygon,
              GeoJSON.GeoJsonProperties
          >
        | GeoJSON.Feature<GeoJSON.Point, GeoJSON.GeoJsonProperties>
): value is GeoJSON.Feature<GeoJSON.Polygon> => {
    return value.geometry.type === "Polygon";
};

export const isPolygonFeature = (
    value: GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>
): value is GeoJSON.Feature<GeoJSON.Polygon> => {
    return value.geometry.type === "Polygon";
};

export const isPointFeature = (
    value: GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>
): value is GeoJSON.Feature<GeoJSON.Point> => {
    return value.geometry.type === "Point";
};

export const isLineStringFeature = (
    value: GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>
): value is GeoJSON.Feature<GeoJSON.LineString> => {
    return value.geometry.type === "LineString";
};

export const isMultiPolygonFeature = (
    value: GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>
): value is GeoJSON.Feature<
    GeoJSON.MultiPolygon,
    GeoJSON.GeoJsonProperties
> => {
    return value.geometry.type === "MultiPolygon";
};

export const isPolygonFeatureCollection = (
    collection: GeoJSON.FeatureCollection<
        GeoJSON.Geometry,
        GeoJSON.GeoJsonProperties
    >
): collection is GeoJSON.FeatureCollection<
    GeoJSON.Polygon | GeoJSON.MultiPolygon,
    GeoJSON.GeoJsonProperties
> => {
    return collection.features.every(
        (feature) =>
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
    );
};
